import Vue from 'vue'
import App from './App'
import router from './router'

import VueI18n from 'vue-i18n' //語言包
import axios from 'axios'
import VueAxios from 'vue-axios'
import 'bootstrap'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
library.add(fas, far)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueI18n) //使用插件語言
Vue.use(VueAxios, axios)
Vue.config.productionTip = false
    //跨域
    //axios.defaults.withCredentials = true;

//語言設定
var i18n = new VueI18n({
        locale: 'en',
        messages: {
            'en': require('@/lang/en.json'),
            'tw': require('@/lang/tw.json')
        }
    })
    /* eslint-disable no-new */
export const app = new Vue({
    el: '#app',
    router,
    i18n, //語言包
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js